import React from 'react';
import {connect} from 'react-redux';
import {connectWithCore} from 'framework/hocs';
import {DynamicSelectField} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicSelectField';

export {DynamicSelectField};
export const mapStateToProps = (state) => {
  return {
    dynamicComponent: state.dynamicComponent,
  };
};
export default connect(mapStateToProps)(connectWithCore(DynamicSelectField));
